export enum EnaioGuiFieldReadOnlyType {
    none = 0,
    always = 1,
    whenInitialised = 2,
    whenInitialisedAndArchived = 3,
    whenArchived = 4,
    left = 5,
    supervisor = 6
}
export namespace EnaioGuiFieldReadOnlyType{
    export function getName(value: EnaioGuiFieldReadOnlyType): string {
        switch (value) {
            case EnaioGuiFieldReadOnlyType.none:
                return "none";
            case EnaioGuiFieldReadOnlyType.always:
                return "always";
            case EnaioGuiFieldReadOnlyType.whenInitialised:
                return "whenInitialised";
            case EnaioGuiFieldReadOnlyType.whenInitialisedAndArchived:
                return "whenInitialisedAndArchived";
            case EnaioGuiFieldReadOnlyType.whenArchived:
                return "whenArchived";
            case EnaioGuiFieldReadOnlyType.left:
                return "left";
            case EnaioGuiFieldReadOnlyType.supervisor:
                return "supervisor";
        }
    }
}
